module.exports = __webpack_public_path__ + "img/logo_vertical.14f01f35.svg";